<template>
  <div class="content-tree sys-center-zuzhijigou">
      <lr-tree
        @setTreeWidth="setTreeWidth" 
        :width="width"
        :ref="bindRef"
        :itemOptions="itemOptions"
        :data="data"
        :filter="true"
        :selectFilter="true"
        :title="title"
        @nodeClick="nodeClick"
        @loadData="loadData"
        :defaultProps="defaultProps"
        :selectID.sync="selectID"
        :bindRef="bindRef"
      ></lr-tree>
  </div>
</template>

<script>
import { getRoleTypeList } from "@/areas/systemmanage/api/role";
import { getWebSiteList } from "@/areas/systemmanage/api/site";
export default {
  name: "LeftRoleType",
  props:{
    width: {
      type: String,
      default: "200px",
    },
  },
  data() {
    return {
      title: "角色类型",
      itemOptions: {
        label: "站点",
        field: "WebSiteID",
        type: "select",
        options: [],
        dicValue: "ID", //值对应的字段
        dicLabel: "Name", //文本对应的字段
        clearable: false,
      },
      data: [{ ID: "", Name: "全部" }],
      defaultProps: {
        label: "Name",
        id: "ID",
      },
      selectID: "",
      bindRef: "tree",
    };
  },
  mounted() {
    this.loadSite();
  },
  methods: {
    setTreeWidth(width){
      this.$emit('setTreeWidth', width)
    },
    loadSite() {
      getWebSiteList({ name: "" }).then((res) => {
        if (res.Code === 200) {
          this.$set(this.itemOptions, "options", res.Data);
          if (res.Data && res.Data.length > 0) {
            this.selectID = res.Data[0].ID;
          }
        }
      });
    },
    nodeClick(node) {
      this.$emit("nodeClick", {
        WebSiteID: this.selectID,
        CategoryID: node.obj[this.defaultProps.id],
      });
    },
    loadData() {
      console.log(1)
      let that = this;
      getRoleTypeList({ WebSiteID: this.selectID }).then((res) => {
        if ((res.Code = 200)) {
          this.data = [{ ID: "", Name: "全部", children: res.Data }];
          this.$nextTick(() => {
            this.$refs[this.bindRef].$refs[this.bindRef].setCurrentKey(
              this.data[0].ID
            );
            this.$emit("nodeClick", {
              WebSiteID: this.selectID,
              CategoryID: this.data[0].ID,
            });
          });
        }
      });
    },
  },
};
</script>
<style scoped  lang="scss">
.leftMenu {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/areas/systemmanage/views/role/components/LeftRoleType.vue